import axios from "axios";

export default axios.create({
    timeout: 1000 * 60, // Wait for 5 seconds
    headers: {
        "Content-type": "application/json"
    }
})